module.exports = __webpack_public_path__ + "img/1048562393.0684f21c.jpg";